
export type GenesysCloudNotificationState = {
  retryCount: number;
};

export const initialState = (): GenesysCloudNotificationState => ({
  retryCount: 0
});
